<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="11">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_label_info_search') ||
                  '英文姓名/中文姓名/手机号/邮箱地址 搜索...'
              "
              style="max-width: 400px;"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <slot></slot>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" label-width="100px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$l('form_label_userStatus') || '账号状态'">
              <el-checkbox-group v-model="form.listUserStatus">
                <el-checkbox label="Y">
                  {{ $l('checkbox_label_userStatusValid') || '有效' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('checkbox_label_userStatusInvalid') || '无效' }}
                </el-checkbox>
                <el-checkbox label="S">
                  {{ $l('checkbox_label_userStatusDisabled') || '停用' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_inspectorUser') || '验货人员'">
              <dict-select
                v-model="form.listUserCode"
                multiple
                filterable
                clearable
                url="/master/common/dict/baseUserSelect"
                :placeholder="
                  $l('form_placeholder_inspectorUser') || '请选择验货人员'
                "
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_inspectorRole') || '验货角色'">
              <dict-select
                v-model="form.listInspectorRole"
                url="/sys/common/dict/system"
                :body="{ dictType: 'DF_INSPECTOR_ROLE' }"
                :placeholder="
                  $l('form_placeholder_inspectorRole') || '请选择验货角色'
                "
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_depName') || '所在部门'">
              <dep-cascader
                :lastValue.sync="form.depCode"
                :placeholder="
                  $l('form_placeholder_depName') || '请选择所在部门'
                "
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_orgName') || '所属公司'">
              <dict-select
                v-model="form.listOrgCode"
                :placeholder="
                  $l('form_placeholder_orgName') || '请选择所属公司'
                "
                url="/sys/common/dict/orgDict"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_displayCreate') || '创建人'">
              <dict-select
                v-model="form.listCreateBy"
                :placeholder="
                  $l('form_placeholder_displayCreate') || '请选择创建人'
                "
                url="/master/common/dict/baseUserSelect"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_createTime') || '创建时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :placeholder="
                      $l('form_placeholder_createTime') || '请选择创建时间'
                    "
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :placeholder="
                      $l('form_placeholder_createTime') || '请选择创建时间'
                    "
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_displayModify') || '修改人'">
              <dict-select
                v-model="form.listModifyBy"
                :placeholder="
                  $l('form_placeholder_displayModify') || '请选择修改人'
                "
                url="/master/common/dict/baseUserSelect"
                filterable
                clearable
                multiple
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-form-item :label="$l('form_label_modifyTime') || '修改时间'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :placeholder="
                      $l('form_placeholder_modifyTime') || '请选择修改时间'
                    "
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                    :placeholder="
                      $l('form_placeholder_modifyTime') || '请选择修改时间'
                    "
                  />
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = { keyword: '', listUserStatus: ['Y', 'N', 'S'] }

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')

      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
</style>
